import {
  createAsyncThunk,
  createSlice,
  PayloadAction,
  SerializedError,
} from '@reduxjs/toolkit'
import { Order } from '../types/order'
// import {
//   CalendarOrder,
//   CreateOrder,
//   Order,
//   UpcomingOrders,
// } from '../types/order'
// import { loadOrders, modifyOrder, removeOrder, saveOrder } from '../api/order'
// import { findCurrentTimePeriodOrders } from '../utils/findCurrentTimePeriodOrders'
// import { isWithinInterval } from 'date-fns'
// import { findOrdersByDate } from '../utils/findOrdersByDate'

// get all orders
// export const getOrders = createAsyncThunk(
//   'order/getOrders',
//   async (_, thunkApi) => {
//     try {
//       return await loadOrders()
//     } catch (e) {
//       return thunkApi.rejectWithValue('getOrdersError')
//     }
//   },
// )

// // add order
// export const addOrder = createAsyncThunk(
//   'order/addOrder',
//   async (order: CreateOrder, thunkApi) => {
//     try {
//       return await saveOrder(order)
//     } catch (e) {
//       return thunkApi.rejectWithValue('addOrderError')
//     }
//   },
// )

// // update order
// export const updateOrder = createAsyncThunk(
//   'order/updateOrder',
//   async (order: Order, thunkApi) => {
//     try {
//       return await modifyOrder(order)
//     } catch (e) {
//       return thunkApi.rejectWithValue('updateOrderError')
//     }
//   },
// )

// // delete objective
// export const deleteOrder = createAsyncThunk(
//   'order/deleteOrder',
//   async (id: string, thunkApi) => {
//     try {
//       return await removeOrder(id)
//     } catch (e) {
//       return thunkApi.rejectWithValue('deleteOrderError')
//     }
//   },
// )

interface OrderSliceState {
  orders: Order[]
  loading: boolean
  error?: SerializedError
}

const initialState: OrderSliceState = {
  orders: [],
  loading: false,
  error: undefined,
}

const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    // setCalendarOrders: (
    //   state: OrderSliceState,
    //   action: PayloadAction<CalendarOrder[]>,
    // ) => {
    //   state.calendarOrders = action.payload
    // },
  },
  // extraReducers: {
  // // get orders
  // [getOrders.fulfilled.type]: (state, action: PayloadAction<Order[]>) => {
  //   state.orders = action.payload
  //   state.orderLoading = false
  //   state.orderError = undefined
  //   state.evensLoaded = true
  // },

  // [getOrders.pending.type]: (state) => {
  //   state.orderLoading = true
  //   state.orderError = undefined
  // },

  // [getOrders.rejected.type]: (state, action) => {
  //   state.orderLoading = false
  //   state.orderError = action.payload
  //   state.evensLoaded = true
  // },

  // // add objective
  // [addOrder.fulfilled.type]: (state, action: PayloadAction<Order>) => {
  //   const orders = state.orders
  //   orders.push(action.payload)
  //   state.orders = orders
  //   state.orderLoading = false
  //   state.orderError = undefined
  // },

  // [addOrder.pending.type]: (state) => {
  //   state.orderLoading = true
  //   state.orderError = undefined
  // },

  // [addOrder.rejected.type]: (state, action) => {
  //   state.orderLoading = false
  //   state.orderError = action.payload
  // },

  // // delete objective
  // [deleteOrder.fulfilled.type]: (state, action: PayloadAction<string>) => {
  //   state.orders = state.orders.filter((order) => order.id !== action.payload)
  //   state.calendarOrders = state.calendarOrders.filter(
  //     (order) => order.id !== action.payload,
  //   )
  //   state.orderLoading = false
  //   state.orderError = undefined
  // },

  // [deleteOrder.pending.type]: (state) => {
  //   state.orderLoading = true
  //   state.orderError = undefined
  // },

  // [deleteOrder.rejected.type]: (state, action) => {
  //   state.orderLoading = false
  //   state.orderError = action.payload
  // },

  // // update orderstatus
  // [updateOrder.fulfilled.type]: (state, action: PayloadAction<Order>) => {
  //   state.orders = state.orders.map((order) =>
  //     order.id === action.payload.id ? action.payload : order,
  //   )
  //   state.calendarOrders = state.calendarOrders.map((order) =>
  //     order.id === action.payload.id
  //       ? {
  //           ...order,
  //           title: order.title,
  //         }
  //       : order,
  //   )
  //   state.orderLoading = false
  //   state.orderError = undefined
  // },

  // [updateOrder.pending.type]: (state) => {
  //   state.orderLoading = true
  //   state.orderError = undefined
  // },

  // [updateOrder.rejected.type]: (state, action) => {
  //   state.orderLoading = false
  //   state.orderError = action.payload
  // },
  // },

  // (builder) => {
  //     builder.addCase(getDevelopers.fulfilled, (state, action) => {
  //         state.developers = action.payload as IDeveloper[];
  //     })

  //     builder.addCase(addDeveloper.fulfilled, (state, action) => {
  //         state.developers.push(action.payload as IDeveloper);
  //     })

  //     builder.addCase(deleteDeveloper.fulfilled, (state, action) => {
  //         state.developers = state.developers.filter(developer => developer.id != action.payload)
  //     })
  // }
})

export const {} = orderSlice.actions
export default orderSlice
